/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { Status } from './Status'
import { StatusFromJSON, StatusFromJSONTyped, StatusToJSON } from './Status'

/**
 *
 * @export
 * @interface EnvelopedStatusSyncStatusRetreive
 */
export interface EnvelopedStatusSyncStatusRetreive {
  /**
   *
   * @type {Status}
   * @memberof EnvelopedStatusSyncStatusRetreive
   */
  body: Status
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedStatusSyncStatusRetreive
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedStatusSyncStatusRetreive interface.
 */
export function instanceOfEnvelopedStatusSyncStatusRetreive(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedStatusSyncStatusRetreiveFromJSON(
  json: any,
): EnvelopedStatusSyncStatusRetreive {
  return EnvelopedStatusSyncStatusRetreiveFromJSONTyped(json, false)
}

export function EnvelopedStatusSyncStatusRetreiveFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedStatusSyncStatusRetreive {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: StatusFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedStatusSyncStatusRetreiveToJSON(
  value?: EnvelopedStatusSyncStatusRetreive | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: StatusToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
